import { post, get } from '@integec/fetch-task'
import { toQueryStr } from 'api/pgads'

export const getUnitTypeInfo = targetInfo => get(targetInfo, 'aepaca/unittypes')

export const postUnitTypeInfo = targetInfo => data =>
  post(targetInfo, 'aepaca/unittypes')(data)

export const deleteUnitTypeInfo = targetInfo => data =>
  post(targetInfo, 'aepaca/unittypes/delete')(data)

export const getUnitTypeInfoByUnit = targetInfo =>
  get(targetInfo, 'aepaca/unittypes-by-unit')

export const postUnitTypeInfoByUnit = targetInfo => data =>
  post(targetInfo, 'aepaca/unittypes-by-unit')(data)

export const deleteUnitTypeInfoByUnit = targetInfo => data =>
  post(targetInfo, 'aepaca/unittypes-by-unit/delete')(data)

export const getunitCapability = targetInfo => qry =>
  get(targetInfo, `aepaca/unitCapability?${toQueryStr(qry)}`)

export const postunitCapability = targetInfo => data =>
  post(targetInfo, 'aepaca/unitCapability')(data)

export const deleteunitCapability = targetInfo => data =>
  post(targetInfo, 'aepaca/unitCapability/delete')(data)

export const getparameter = targetInfo => get(targetInfo, 'aepaca/parameter')

export const postparameter = targetInfo => data =>
  post(targetInfo, 'aepaca/parameter')(data)

export const deleteparameter = targetInfo => data =>
  post(targetInfo, 'aepaca/parameter/delete')(data)

export const getclassAvgStat = targetInfo => ({ year }) =>
  get(targetInfo, 'aepaca/classAvgStat?year=' + year)

export const postclassAvgStat = targetInfo => data =>
  post(targetInfo, 'aepaca/classAvgStat')(data)

export const deleteclassAvgStat = targetInfo => data =>
  post(targetInfo, 'aepaca/classAvgStat/delete')(data)

export const getcausecode = targetInfo => get(targetInfo, 'aepaca/causecode')

export const postcausecode = targetInfo => data =>
  post(targetInfo, 'aepaca/causecode')(data)

export const deletecausecode = targetInfo => data =>
  post(targetInfo, 'aepaca/causecode/delete')(data)

export const getseason = targetInfo => get(targetInfo, 'aepaca/season')

export const postseason = targetInfo => data =>
  post(targetInfo, 'aepaca/season')(data)

export const deleteseason = targetInfo => data =>
  post(targetInfo, 'aepaca/season/delete')(data)

export const getnplh = targetInfo => data =>
  get(targetInfo, `aepaca/nplh?` + toQueryStr(data))

export const postnplh = targetInfo => data =>
  post(targetInfo, 'aepaca/nplh')(data)

export const deletenplh = targetInfo => data =>
  post(targetInfo, 'aepaca/nplh/delete')(data)
